import * as yup from 'yup';
import { propertyContractBaseSchema } from '@/features/Contract/Property/contractBaseSchema';
import { elementarSchema } from '@/features/Sparten/shared/schema/property/contract/elementarSchema';
import { insuredObjectBaseSchema } from '@/features/Sparten/shared/schema/property/contract/insuredObjectBaseSchema';
import { propertyPreviousDamageSharedWithElementarAndGlas } from '@/features/Contract/Property/contractBaseSchemaWithElementarAndGlas';

const hauContractSchema = insuredObjectBaseSchema.concat(
  yup.object({
    elementargefahren: elementarSchema,
    fertighaus: yup.object({
      hersteller: yup.string().default(''),
    }),
    mindestsicherungen: yup.boolean().default(true),
    einbruch: yup.boolean().default(false),
    vorschaden: propertyPreviousDamageSharedWithElementarAndGlas,
  }),
);

export const contractSchema =
  propertyContractBaseSchema.concat(hauContractSchema);
